"use client";

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { cn } from "@/lib/utils";
import { Button } from "@/components/atoms/button";
import { Search } from 'lucide-react';
import { NavigationMenu, NavigationMenuList } from "@/components/atoms/navigation-menu";
import { NavMenuItem } from "@/components/molecules/NavMenuItem";
import type { NavLink, ContactLink } from "./Header.props";
import { Box } from "@/components/atoms/Box";
import { Text } from "@/components/atoms/Text";
interface DesktopNavProps {
  links: NavLink[];
  contactLink?: ContactLink;
  isTransparent: boolean;
}
export const DesktopNav = t0 => {
  const $ = _c(20);
  const {
    links,
    contactLink,
    isTransparent
  } = t0;
  let t1;
  if ($[0] !== isTransparent || $[1] !== links) {
    let t2;
    if ($[3] !== isTransparent) {
      t2 = link => <NavMenuItem key={link.label} link={link} isTransparent={isTransparent} />;
      $[3] = isTransparent;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = links.map(t2);
    $[0] = isTransparent;
    $[1] = links;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <NavigationMenu aria-label="Main" role="navigation" className="max-lg:hidden" viewport={false}><NavigationMenuList>{t1}</NavigationMenuList></NavigationMenu>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = isTransparent ? "text-white hover:bg-white/10" : "text-foreground hover:bg-accent hover:text-accent-foreground";
  let t4;
  if ($[7] !== t3) {
    t4 = cn("flex items-center justify-center w-10 h-10 rounded-full", "transition-colors duration-200 ease-in-out", t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Search className="w-5 h-5" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <Link href="/search" className={t4} aria-label="Search">{t5}</Link>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== contactLink) {
    t7 = contactLink && <Button asChild={true} className="transition-transform duration-150 hover:scale-105 active:scale-95" aria-label={contactLink.label}><Link href={contactLink.href}><Text className="relative z-10">{contactLink.label}</Text></Link></Button>;
    $[12] = contactLink;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <Box className="max-lg:hidden flex items-center gap-2">{t6}{t7}</Box>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t8) {
    t9 = <>{t2}{t8}</>;
    $[17] = t2;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};